/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Postponedto1Inputs */

const en_postponedto1 = /** @type {(inputs: Postponedto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postponed to`)
};

const de_postponedto1 = /** @type {(inputs: Postponedto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschoben auf`)
};

/**
* | output |
* | --- |
* | "Postponed to" |
*
* @param {Postponedto1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const postponedto1 = /** @type {((inputs?: Postponedto1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Postponedto1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_postponedto1(inputs)
	return de_postponedto1(inputs)
});
export { postponedto1 as "postponedTo" }